import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import Grid from '../Grid';
import { MEarningPotentialsHeader, translateHeaders } from './helpers/HeadersList';
import { requireTitle } from './helpers/utils';
import { numberValidator } from '../Validators';

export const MEarningPotentials: FC<{
    list: IList;
    toolId: number;
}> = ({ list, toolId }) => {
    const translatedHeaders = translateHeaders(MEarningPotentialsHeader);

    return (
        <Grid toolId={toolId} headers={MEarningPotentialsHeader} list={list}>
            <HotColumn type="text" title={requireTitle(translatedHeaders[0])} />
            <HotColumn
                type="numeric"
                validator={numberValidator()}
                allowEmpty={false}
                title={requireTitle(translatedHeaders[1])}
            />
        </Grid>
    );
};
